import { fromJS } from 'immutable';

import productLines from './productLines';
import type {
  ProductButtonAction,
  ProductName,
  ProductSettingPayload,
} from './product-settings.types';
export const GET_PRODUCT_TYPES = 'react-boilerplate/PRODUCTS/GET_PRODUCT_TYPES';
export const ADD_SETTING_LINE = 'react-boilerplate/PRODUCTS/ADD_SETTING_LINE';
export const GET_SETTING_LINE = 'react-boilerplate/PRODUCTS/GET_SETTING_LINE';
export const SAVE_SETTING_LINE = 'react-boilerplate/PRODUCTS/SAVE_SETTING_LINE';
export const DELETE_SETTING_LINE = 'react-boilerplate/PRODUCTS/DELETE_SETTING_LINE';

export const getProductTypes = (
  shopId: string,
  product: ProductName,
  type: string,
  typeIndex: number,
) => ({
  type: GET_PRODUCT_TYPES,
  shopId,
  product,
  typeIndex,
  meta: {
    type: 'api',
    url: `shop/${shopId}/products/${product}/${type}`,
    method: 'get',
  },
});

export const addSettingLine = (
  shopId: string,
  product: ProductName,
  typeIndex: number,
  itemIndex: number,
  type: string,
) => ({
  type: ADD_SETTING_LINE,
  shopId,
  product,
  typeIndex,
  itemIndex,
  newData: fromJS(productLines(itemIndex)[product][type]),
});

export const getSettingLine = (
  shopId: string,
  product: ProductName,
  type: string,
  typeIndex: number,
  settingLineId: number,
) => ({
  type: GET_SETTING_LINE,
  shopId,
  product,
  settingLineId,
  typeIndex,
  meta: {
    type: 'api',
    url: `shop/${shopId}/products/${product}/${type}/items/${settingLineId}`,
    method: 'get',
  },
});

export const saveSettingLine = (
  shopId: string,
  product: ProductName,
  type: string,
  typeIndex: number,
  settingLineId: number,
  values: ProductSettingPayload,
  buttonAction: ProductButtonAction,
  newSettingLine?: boolean,
) => ({
  type: SAVE_SETTING_LINE,
  shopId,
  product,
  typeIndex,
  settingLineId,
  values,
  buttonAction,
  meta: {
    type: 'api',
    url: newSettingLine ? `shop/${shopId}/products/${product}/${type}` : `shop/${shopId}/products/${product}/${type}/items/${settingLineId}`,
    method: newSettingLine ? 'post' : 'put',
    data: values,
  },
});

export const deleteSettingLine = (
  shopId: string,
  product: ProductName,
  type: string,
  typeIndex: number,
  settingLineId: number,
) => ({
  type: DELETE_SETTING_LINE,
  shopId,
  product,
  typeIndex,
  settingLineId,
  meta: {
    type: 'api',
    url: `shop/${shopId}/products/${product}/${type}/items/${settingLineId}`,
    method: 'delete',
  },
});
